import { ReactElement } from "react";

import { Button } from "react-bulma-components";
import styled from "styled-components";

import * as Table from "molecules/Table";

const Title = styled.h4`
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

const renderCompletedMessage = (numApplications: number, name: string) => (
  <div>
    <Title className="title is-4">
      {numApplications} 件の
      {name}
      承認が完了しました
    </Title>
  </div>
);

export interface BulkApprovalDialogProps {
  isVisible: boolean;
  isUpdateCompleted: boolean;
  isUpdateInProgress: boolean;
  numApplications: number;
  toggleDialog: () => void;
  updateAllToApprove: () => void;
  name: string;
}

export function BulkApprovalDialog({
  isVisible,
  isUpdateCompleted,
  isUpdateInProgress,
  numApplications,
  toggleDialog,
  updateAllToApprove,
  name,
}: BulkApprovalDialogProps): ReactElement | null {
  return (
    <div className={`modal ${isVisible ? "is-active" : ""}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">一括承認</p>
          <button
            type="button"
            disabled={isUpdateInProgress}
            className="delete"
            aria-label="close"
            onClick={(_event) => toggleDialog()}
          />
        </header>
        <section className="modal-card-body">
          {isUpdateCompleted && renderCompletedMessage(numApplications, name)}
          <Table.Table>
            <tbody>
              <tr>
                <Table.Th>承認件数</Table.Th>
                <Table.Td>{numApplications} 件</Table.Td>
              </tr>
            </tbody>
          </Table.Table>
        </section>
        <footer className="modal-card-foot">
          <Button disabled={isUpdateInProgress} onClick={() => toggleDialog()}>
            {isUpdateCompleted ? "閉じる" : "キャンセル"}
          </Button>
          {!isUpdateCompleted && (
            <Button
              disabled={isUpdateInProgress || numApplications === 0}
              color="primary"
              onClick={() => updateAllToApprove()}
            >
              一括承認
            </Button>
          )}
        </footer>
      </div>
    </div>
  );
}
